import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

import appReducer from '../../data/appSlice';
import { eventsApi } from '../../services/api/eventsApi';
import { monitorsApi } from '../../services/api/monitorsApi';
import { statisticsApi } from '../../services/api/statisticsApi';
import { streamsApi } from '../../services/api/streamsApi';
import { timeseriesApi } from '../../services/api/timeseriesApi';
import langReducer from '../lang/langSlice';
import loginReducer from '../login/loginSlice';
import tokenReducer from '../tokenHandling/tokenSlice';
import configReducer from './configSlice';

export const store = configureStore({
    reducer: {
        config: configReducer,
        lang: langReducer,
        app: appReducer,
        login: loginReducer,
        tokenHandling: tokenReducer,

        // Add the generated reducer as a specific top-level slice
        [streamsApi.reducerPath]: streamsApi.reducer,
        [eventsApi.reducerPath]: eventsApi.reducer,
        [statisticsApi.reducerPath]: statisticsApi.reducer,
        [monitorsApi.reducerPath]: monitorsApi.reducer,
        [timeseriesApi.reducerPath]: timeseriesApi.reducer,
    },

    // Adding the api middleware enables caching, invalidation, polling,
    // and other useful features of `rtk-query`.
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware().concat(
            streamsApi.middleware,
            eventsApi.middleware,
            statisticsApi.middleware,
            monitorsApi.middleware,
            timeseriesApi.middleware
        ),
});

// Infer the `RootState` and `RootDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type RootDispatch = typeof store.dispatch;

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
setupListeners(store.dispatch);
